import { render, staticRenderFns } from "./RevisionReasonStep.vue?vue&type=template&id=670240f6&scoped=true&"
import script from "./RevisionReasonStep.vue?vue&type=script&lang=js&"
export * from "./RevisionReasonStep.vue?vue&type=script&lang=js&"
import style0 from "./RevisionReasonStep.vue?vue&type=style&index=0&id=670240f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670240f6",
  null
  
)

export default component.exports